<div [ngClass]="blue ? 'blue-theme' : 'red-theme'">
    <div *ngIf="player && player._id" class="player-container">
        <div class="over-player-container"></div>
        <div class="player-img" [ngClass]="{ 
            'image-badge': flag,
            'sorare': isBigImage(),
            }">
            <div><img *ngIf="player.imgUrl" [src]="player.imgUrl" [alt]="player.name"></div>
        </div>
        <div class="naming">
            <p autoscaleText [minFontSize]="6" [maxFontSize]="18">{{player.commonName ? player.commonName : player.name}}</p>
        </div>
        <div *ngIf="flag" class="player-flag">
            <img *ngIf="!blue && player.currentTeam" [src]="player.currentTeam.imgUrl" [alt]="player.currentTeam.name">
            <img [src]="player.nation | flag" [alt]="player.nation">
        </div>
    </div>
    <div *ngIf="player && !player._id" class="chapa">
        <div class="chapa-over"></div>
        <p class="chapa-label">{{player.commonName ? player.commonName : player.name}}</p>
    </div>
</div>
